import { http } from '@/http/index'

async function confirmAge() {
	return http.post('/consumer/confirm-age')
}

export { confirmAge }
